import axiosInstance from '@/app/api/axiosInstance';
import { Unit, UnitCreate, UnitUpdate } from '@/app/types/unit';
import { PaginatedResponse, ListQueryParams } from '@/app/types/api';
import { createOrganizationFilter } from '@/app/utils/filterUtils';

export const listUnits = async (params: ListQueryParams, organizationId: number): Promise<PaginatedResponse<Unit>> => {
  try {
    const requestParams = {
      ...params,
      ...(params.filters && typeof params.filters === 'string'
        ? { filters: params.filters }
        : organizationId 
            ? { filters: createOrganizationFilter(organizationId) }
            : {}),
      include_global: true, // Include global units
    };

    const response = await axiosInstance.get<PaginatedResponse<Unit>>('/units/', { 
      params: requestParams 
    });
    
    return response.data;
  } catch (error) {
    console.error('Failed to list units:', error);
    throw error;
  }
};

export const getUnit = async (unitId: number): Promise<Unit> => {
  try {
    const response = await axiosInstance.get<Unit>(`/units/${unitId}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to get unit with ID ${unitId}:`, error);
    throw error;
  }
};

export const createUnit = async (data: UnitCreate, organizationId: number): Promise<Unit> => {
  try {
    const unitData = {
      ...data,
      organization_id: organizationId
    };
    
    const response = await axiosInstance.post<Unit>('/units/', unitData);
    return response.data;
  } catch (error) {
    console.error('Failed to create unit:', error);
    throw error;
  }
};

export const updateUnit = async (unitId: number, data: UnitUpdate): Promise<Unit> => {
  try {
    const response = await axiosInstance.patch<Unit>(`/units/${unitId}`, data);
    return response.data;
  } catch (error) {
    console.error(`Failed to update unit with ID ${unitId}:`, error);
    throw error;
  }
};

export const deleteUnit = async (unitId: number): Promise<void> => {
  try {
    await axiosInstance.delete(`/units/${unitId}`);
  } catch (error) {
    console.error(`Failed to delete unit with ID ${unitId}:`, error);
    throw error;
  }
}; 